import { apiClient } from "../../../base/ApiClient";

export const getFunders = async (params = {}) => {
  const response = await apiClient.get('/billing/funders/', { params });
  return response.data;
};

export const searchFunders = async (search) => {
  const response = await apiClient.get(`/billing/funders/?search=${search}`);
  return response.data;
};

export const getFunderById = async (id) => {
  const response = await apiClient.get(`/billing/funders/${id}/`);
  return response.data;
};

export const createFunder = async (data) => {
  const response = await apiClient.post('/billing/funders/', data);
  return response.data;
};

export const updateFunder = async (id, data) => {
  const response = await apiClient.put(`/billing/funders/${id}/`, data);
  return response.data;
};

export const deleteFunder = async (id) => {
  const response = await apiClient.delete(`/billing/funders/${id}/`);
  return response.data;
};

export const getFundersLookup = async (category = 'COUNCIL') => {
  const response = await apiClient.get(`/billing/funders/lookup/?category=${category}`);
  return response.data;
};